<template>
  <div class="iframe-container">
    <iframe  src="http://localhost:5555/#/companies"/>
  </div>
</template>

<style  scoped>
.iframe-container {
  overflow: hidden;
  padding-top: 45%;
  position: relative;
}

.iframe-container iframe {
   border: 0;
   height: 100%;
   left: 0;
   position: absolute;
   top: 0;
   width: 100%;
}
</style>

<script>

export default {
  name: 'AppsApp',
  props: {
    alert: {type:Boolean, required:false, default:false}
  },
  data() {
    return {
      showAlert: this.alert,
    }
  },
  computed: {
    permissions() {
      return this.$store.getters.company.permissions;
    },
  },
  methods: {
    async clearAlerts() {
      if (!this.alert)
        return;

      await this.$apiCall(`mutation AppsQbo {setAlertForAddOn(name:"Square",on:false)}`, {});
      await this.$store.dispatch('checkTasks', true);
      this.showAlert = false;
    }
  }
}
</script>